import { logger } from '@tuic/logger';
import { Account } from '../../index';
import { cache } from 'react';

export const getManifest = async (
  idToken: string,
  mpi: number,
): Promise<Account.ManifestFeed | null> => {
  const { data, error } = await Account.getManifest({
    path: { mpi },
    auth: idToken,
  });

  if (data) return data;

  logger.error(`Fetching manifest for MPI "${mpi}" failed.`);
  logger.error(error);

  return null;
};

export const memoizedGetManifest: typeof getManifest = cache(getManifest);

export const storeManifest = async (
  idToken: string,
  mpi: number,
  body: Account.ManifestDetail,
): Promise<{
  data?: Account.ManifestFeed;
  status?: number;
  error?: unknown;
}> => {
  // eslint-disable-next-line no-console
  console.log(
    '[storeManifest] POST',
    JSON.stringify({ mpi, body }, null, 2),
  );

  const { data, error, response } = await Account.storeManifest({
    path: { mpi }, body, auth: idToken,
  });

  console.log(
    '[storeManifest] RESPONSE',
    JSON.stringify({ status: response.status, error }, null, 2),
  );

  if (data) return { data };

  return { error, status: response.status };
};
